import _ from 'lodash';
import PropTypes from 'prop-types';
import {Component} from 'react';
import QueryUtils from '@wix/wixrest-utils/dist/QueryUtils';
import React from 'react';

let ____popup = null;
let ____popupuniqueid = null;
let onDone = null;
let onSave = null;
let onUpdate = null;
let onPublish = null;

class _PopupProvider extends Component {

    constructor() {
        super();

        this.state = {
            uniqueId : null,
            latestUniqueId : null
        };
    }

    componentWillMount() {
        this.pageIdPromise = new Promise(resolve => {
            Wix.getCurrentPageId(id => {
                this.pageId = id;
                resolve();
            });
        })
    }

    componentDidMount() {
        Wix.addEventListener(Wix.Events.DEVICE_TYPE_CHANGED, () => this._openPopup());
        Wix.addEventListener(Wix.Events.EDIT_MODE_CHANGE, () => this._openPopup());
        Wix.addEventListener(Wix.Events.PAGE_NAVIGATION, () => this._openPopup());

        this._openPopup();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.proceedingToBranch !== this.props.proceedingToBranch) {
            this._openPopup();
        }
    }

    _openPopup() {
        this.pageIdPromise.then(() => {

            console.log('[Popup] openPopup!');

            ____popupuniqueid = null;

            Wix.PubSub.publish('popupsdestroy');

            const uniqueId = '' + Math.random();
            let url = `${window.location.protocol}//${window.location.host}?type=${this.props.type}&uniqueId=${uniqueId}&forcePageId=${this.pageId}`;

            const {selectedBranchId} = this.props;

            if (selectedBranchId) {
                console.log('[Popup] opening chain\'s branch id', selectedBranchId);
                url += `&orgForceId=${selectedBranchId}`;
            }

            try {
                Wix.openPopup(url, '100%', '0%', Wix.WindowPlacement.FIXED_RIGHT, null, Wix.Theme.BARE);
            } catch (e) {
                console.log('[Popup] couldn\'t open popup with url', url, e);
            }

            this.setState({latestUniqueId: uniqueId, uniqueId: null});

            Wix.PubSub.subscribe(uniqueId + 'listening', () => {
                if (uniqueId !== this.state.latestUniqueId) return;
                ____popupuniqueid = uniqueId;
                if (____popup) ____popup.setState({____popupuniqueid: uniqueId});
            });

            Wix.PubSub.subscribe(uniqueId + 'closing', (params) => {
                if (uniqueId !== this.state.latestUniqueId || uniqueId !== ____popupuniqueid) return;

                if (onDone) {
                    let data = (params || {}).data;
                    if (_.isEmpty(data)) data = null;
                    console.log('[Popup] onDone!', data);
                    onDone(data);
                    onDone = null;
                }

                $(window).focus();
            });

            Wix.PubSub.subscribe(uniqueId + 'saving', (params) => {
                if (onSave) {
                    onSave(params.data);
                }
            });

            Wix.PubSub.subscribe(uniqueId + 'update', (params) => {
                if (onUpdate) {
                    onUpdate(params.data);
                }
            });

            Wix.PubSub.subscribe(uniqueId + 'publish', (params) => {
                if (onPublish) {
                    onPublish(params.data);
                }
            });
        });
    }

    render() {
        return this.props.children;
    }
}

_PopupProvider.displayName = '_PopupProvider';

export const PopupProvider = _PopupProvider;

class _Popup extends Component {
    constructor() {
        super();

        this.state = {
            renderLoading : false
        };
    }

    render() {
        if (this.state.renderLoading && this.props.showLoading) {
            // TODO: Spinner
            return (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    zIndex: '99999',
                    backgroundColor: 'rgba(0,0,0,0.2)'
                }}>
                    <div className='preloadSpinnerWrapper'>
                        <div className='preloadSpinnerContainer'>
                            <svg viewBox='0 0 44 44' className='preloadSpinner'>
                                <circle cx='22' cy='22' r='20' fill='none' className='path'></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }

    getPopupOpenDTO() {
        let {data = {}, type} = this.props;
        // let orderingTimeManager = OrderingTimeManager.serialize();
        let dto = {...data, type};
        return dto;
    }

    componentDidMount() {
        onDone = this.props.onDone;
        onSave = this.props.onSave;
        onUpdate = this.props.onUpdate;
        onPublish = this.props.onPublish;

        if (____popupuniqueid) {
            let dto = this.getPopupOpenDTO();
            console.log('[Popup] open', dto);

            Wix.PubSub.publish(____popupuniqueid + 'open', dto);
        } else {
            const This = this;
            ____popup = This;
            this.setState({renderLoading:true});
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if ((!prevState.____popupuniqueid) && (this.state.____popupuniqueid)) {
            let dto = this.getPopupOpenDTO();
            console.log('[Popup] delayed open', dto);
            Wix.PubSub.publish(this.state.____popupuniqueid + 'open', dto);
            this.setState({renderLoading:false});
        } else {
            Wix.PubSub.publish(____popupuniqueid + 'updateProps', {
                props: this.props
            });
        }
    }

    componentWillUnmount() {
        ____popup = null;
        if (____popupuniqueid) {
            Wix.PubSub.publish(____popupuniqueid + 'close');
            onSave = null;
            onUpdate = null;
            onPublish = null;
        }
    }
}

_Popup.displayName = '_Popup'
_Popup.propTypes = {
    showLoading: PropTypes.bool
};
_Popup.defaultProps = function () {
    return {
        showLoading: true
    };
}

export const Popup = _Popup;

export class UpdatablePopup extends React.Component {
    static displayName = 'UpdatablePopup';
    state = {};

    componentDidMount() {
        const queryHash = QueryUtils.buildQueryHash();
        Wix.PubSub.subscribe(queryHash.uniqueId + 'updateProps', this.onUpdate);
    }

    componentWillUnmount() {
        const queryHash = QueryUtils.buildQueryHash();
        Wix.PubSub.unsubscribe(queryHash.uniqueId + 'updateProps', this.onUpdate);
    }

    onUpdate = (params) => {
        this.setState({
            outerProps: params.data.props.data
        });
    };

    render() {
        let outerProps = this.state.outerProps || this.props.outerProps

        return (<div>
            {React.createElement(this.props.element, {
                onSave: this.props.onSave,
                onClose: this.props.onClose,
                onUpdate: this.props.onUpdate,
                onPublish: this.props.onPublish,
                ...outerProps,
                loadRemote: false
            })}
        </div>);
    }
}

